import { createContext } from "react";
const ColumnHidingContext = /*#__PURE__*/createContext({
  hiddenColumns: [],
  columnDecorator: column => column
});
export default ColumnHidingContext;